import './App.css';
import { Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";
import Car24Login from "./Login.tsx";
import Car24StoreHome from "./Home.tsx";

function App() {
  const [isAuth, setIsAuth] = useState(
    !!localStorage.getItem("car24_auth_token")
  );

  async function onLogin({ username, password }) {
    const res = await fetch(
      "https://chamcore.com/chameleon/Api/ApiController/car24Login",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      }
    );

    if (!res.ok) {
      throw new Error("Invalid username or password");
    }

    const data = await res.json();
    localStorage.setItem("car24_auth_token", data.token);
    setIsAuth(true); // ✅ THIS triggers rerender
  }

  function logout() {
    localStorage.removeItem("car24_auth_token");
    setIsAuth(false);
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuth ? <Navigate to="/home" replace /> : <Car24Login onLogin={onLogin} />
        }
      />

      <Route
        path="/home"
        element={
          isAuth ? <Car24StoreHome handleLogout={logout} /> : <Navigate to="/" replace />
        }
      />
    </Routes>
  );
}

export default App;
